import React, { useEffect } from "react";
import { CssBaseline } from "@mui/material";
import { ThemeProvider } from "@mui/material/styles";
import { adminTheme } from "./theme/theme";
import AppRealtor from "./AppRealtor";
import { applySeasonToDocument } from "./public/halloween/season";

/**
 * Wrapper for the realtor panel: applies the admin theme and keeps the
 * document title distinct from the public site. Everything behind this
 * component requires a Cognito sign-in (see AppRealtor).
 */
export default function AdminApp() {
  useEffect(() => {
    document.title = "Панель рієлтора — LeoCity";
  }, []);

  // The seasonal font and page-wide colours, as on the public site.
  useEffect(applySeasonToDocument, []);

  return (
    <ThemeProvider theme={adminTheme}>
      <CssBaseline />
      <AppRealtor />
    </ThemeProvider>
  );
}
